import { useRecoilValue } from 'recoil';
import WorkspaceDarkIconSVG from '~/assets/workspace-icon-dark.svg';
import WorkspaceLightIconSVG from '~/assets/workspace-icon-light.svg';
import { themeState } from '~/state/atoms/themeAtoms';

export default function WorkspaceIcon({ height = 24 }: { height?: number }) {
    const theme = useRecoilValue(themeState);
    return (
        <img
            src={
                theme === 'dark' ? WorkspaceLightIconSVG : WorkspaceDarkIconSVG
            }
            alt=""
            width="auto"
            height={height}
            style={{ pointerEvents: 'none', marginTop: '1px' }}
        />
    );
}
